import { render, staticRenderFns } from "./SelectOrgCategory.vue?vue&type=template&id=62be73e3"
import script from "./SelectOrgCategory.vue?vue&type=script&lang=js"
export * from "./SelectOrgCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports